import {
  type UpgradeFormatter,
  defaultUpgradeView,
} from "@/design-system/Evolution/Levels";
import {
  useEvoRowLabel,
  useEvoRowValue,
} from "@/pages/EvolutionsHub/EvolutionsBuilder/components/evoDisplayUtils";

/**
 * How an upgrade reads on a level card, localised: stat rows through the
 * shared label/value hooks; PlayStyles and roles as their art, the same as
 * the default view.
 */
export const useUpgradeFormatter = (): UpgradeFormatter => {
  const rowLabel = useEvoRowLabel();
  const rowValue = useEvoRowValue();
  return (upgrade) => {
    const view = defaultUpgradeView(upgrade);
    if (view.kind === "icon" || view.kind === "chip") return view;
    if (upgrade.type === "playstyle") return view;
    return { label: rowLabel(upgrade), value: rowValue(upgrade) };
  };
};
